import {getSubtitle, getTitle} from '../../../../../ui/core/nutshell-fields/helpers';
import type {FormSchemaProperty} from '../../../../../ui/core/nutshell-fields/types';

import {ButtonCard} from '../card/button-card';
import {getIcon, getIconColor} from '../nutshell-fields/entity-icon';
import {NutshellFieldCardContent} from '../nutshell-fields/nutshell-field-card-content';

interface Props {
    field: FormSchemaProperty;
    isSelected?: boolean;
    onClick: () => void;
}

export function CustomFieldCard(props: Props) {
    const Icon = getIcon(props.field.entityType);
    const iconColor = getIconColor(props.field.entityType);
    const title = getTitle(props.field);
    const subtitle = getSubtitle(
        props.field.entityType,
        props.field.isCustomField,
        props.field.displayType
    );

    return (
        <ButtonCard fitHeight={true} isSelected={props.isSelected} onClick={props.onClick}>
            <div className='px-12 py-8 full-height border-box'>
                <NutshellFieldCardContent
                    label={title}
                    icon={Icon}
                    variant='small'
                    iconColor={iconColor}
                    subtitle={subtitle}
                    entityType={props.field.entityType}
                />
            </div>
        </ButtonCard>
    );
}
